import { genHtmlOptions, genMenuItems, genOptions } from '../utils';

export { bookingStatesMenuItems } from '../trips/UserManager/utils';

type IntStringMap = {
    [key: number]: string;
};
type StringStringMap = {
    [key: string]: string;
};

export const RENDERING_TYPES: IntStringMap = {};
export const RENDERING_TYPE_STANDARD = 0;
export const RENDERING_TYPE_CUSTOM = 1;
RENDERING_TYPES[RENDERING_TYPE_STANDARD] = 'Standard';
RENDERING_TYPES[RENDERING_TYPE_CUSTOM] = 'Custom';

export const EVENTS: StringStringMap = {};
export const USER_MAGIC_LINK = 'user.magic_link';
export const USER_APP_DOWNLOADED = 'user.app_downloaded';
export const TOUR_PARTICIPANT_CREATED = 'tour_participant.created';
export const TOUR_PARTICIPANT_UPDATED = 'tour_participant.updated';
export const TOUR_PARTICIPANT_DELETED = 'tour_participant.deleted';
export const BOOKING_PRECHECKIN_COMPLETED = 'booking.precheckin_completed';
export const ORDER_CREATED = 'order.created';
export const ORDER_UPDATED = 'order.updated';
export const ORDER_PRETRIP_0M = 'order.0m';
export const ORDER_PRETRIP_5M = 'order.5m';
export const ORDER_PRETRIP_30M = 'order.30m';
export const ORDER_PRETRIP_70M = 'order.70m';
export const ORDER_PRETRIP_1H = 'order.1h';
export const ORDER_PRETRIP_2H = 'order.2h';
export const ORDER_PRETRIP_115H = 'order.115h';
export const ORDER_PRETRIP_12H = 'order.12h';
export const ORDER_PRETRIP_135H = 'order.135h';
export const ORDER_PRETRIP_16H = 'order.16h';
export const ORDER_PRETRIP_20H = 'order.20h';
export const ORDER_PRETRIP_24H = 'order.24h';
export const ORDER_PRETRIP_48H = 'order.48h';
export const ORDER_PRETRIP_72H = 'order.72h';
export const ORDER_PRETRIP_5D = 'order.5d';
export const ORDER_PRETRIP_7D = 'order.7d';
export const ORDER_PRETRIP_9D = 'order.9d';
export const ORDER_PRETRIP_10D = 'order.10d';
export const ORDER_PRETRIP_14D = 'order.14d';
export const ORDER_PRETRIP_30D = 'order.30d';
export const ORDER_ONTRIP_5M = 'order.ontrip5m';
export const ORDER_ONTRIP_10M = 'order.ontrip10m';
export const ORDER_ONTRIP_15M = 'order.ontrip15m';
export const ORDER_ONTRIP_45M = 'order.ontrip45m';
export const ORDER_ONTRIP_3H = 'order.ontrip3h';
export const ORDER_ONTRIP_4H = 'order.ontrip4h';
export const ORDER_ONTRIP_45H = 'order.ontrip45h';
export const ORDER_ONTRIP_6H = 'order.ontrip6h';
export const ORDER_ONTRIP_8H = 'order.ontrip8h';
export const ORDER_ONTRIP_10H = 'order.ontrip10h';
export const ORDER_ONTRIP_24H = 'order.ontrip24h';
export const ORDER_ENDTRIP_1H = 'order.endtrip1h';
export const ORDER_ENDTRIP_24H = 'order.endtrip24h';
export const ORDER_ENDTRIP_48H = 'order.endtrip48h';
export const ORDER_POST_20M = 'order.post20m';
export const ORDER_POST_1H = 'order.post1h';
export const ORDER_POST_2H = 'order.post2h';
export const ORDER_POST_12H = 'order.post12h';
export const ORDER_POST_24H = 'order.post24h';
export const ORDER_POST_36H = 'order.post36h';
export const ORDER_POST_48H = 'order.post48h';
export const ORDER_POST_72H = 'order.post72h';
export const ORDER_POST_10D = 'order.post10d';
export const ORDER_POST_29D = 'order.post29d';
export const ORDER_POST_1Y = 'order.post1y';
// export const ORDER_POSTBOOKING_3H = 'order.postbooking3h';
// export const ORDER_POSTBOOKING_24H = 'order.postbooking24h';
// export const ORDER_POSTBOOKING_48H = 'order.postbooking48h';
// export const ORDER_ABANDONED_CART = 'order.abandoned_cart';


export const TOUR_PARTICIPANT_TRIP_START = 'tour_participant.trip_start';
export const TOUR_PARTICIPANT_TRIP_ABOUT_TO_BEGIN = 'tour_participant.trip_about_to_begin';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_30D = 'tour_participant.trip_flag_event_30d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_14D = 'tour_participant.trip_flag_event_14d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_10D = 'tour_participant.trip_flag_event_10d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_9D = 'tour_participant.trip_flag_event_9d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_7D = 'tour_participant.trip_flag_event_7d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_5D = 'tour_participant.trip_flag_event_5d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_72H = 'tour_participant.trip_flag_event_72h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_48H = 'tour_participant.trip_flag_event_48h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_20H = 'tour_participant.trip_flag_event_20h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_16H = 'tour_participant.trip_flag_event_16h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_135H = 'tour_participant.trip_flag_event_135h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_12H = 'tour_participant.trip_flag_event_12h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_115H = 'tour_participant.trip_flag_event_115h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_2H = 'tour_participant.trip_flag_event_2h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_70M = 'tour_participant.trip_flag_event_70m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_30M = 'tour_participant.trip_flag_event_30m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_5M = 'tour_participant.trip_flag_event_5m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_0M = 'tour_participant.trip_flag_event_0m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST20M = 'tour_participant.trip_flag_event_post20m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST1H = 'tour_participant.trip_flag_event_post1h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST12H = 'tour_participant.trip_flag_event_post12h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST24H = 'tour_participant.trip_flag_event_post24h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST36H = 'tour_participant.trip_flag_event_post36h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST48H = 'tour_participant.trip_flag_event_post48h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST72H = 'tour_participant.trip_flag_event_post72h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST10D = 'tour_participant.trip_flag_event_post10d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST29D = 'tour_participant.trip_flag_event_post29d';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST1Y = 'tour_participant.trip_flag_event_post1y';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP5M = 'tour_participant.trip_flag_event_ontrip5m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP10M = 'tour_participant.trip_flag_event_ontrip10m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP15M = 'tour_participant.trip_flag_event_ontrip15m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP3H = 'tour_participant.trip_flag_event_ontrip3h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP4H = 'tour_participant.trip_flag_event_ontrip4h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP45M = 'tour_participant.trip_flag_event_ontrip45m';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP45H = 'tour_participant.trip_flag_event_ontrip45h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP6H = 'tour_participant.trip_flag_event_ontrip6h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP8H = 'tour_participant.trip_flag_event_ontrip8h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP10H = 'tour_participant.trip_flag_event_ontrip10h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP24H = 'tour_participant.trip_flag_event_ontrip24h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING1H = 'tour_participant.trip_flag_event_postbooking1h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING3H = 'tour_participant.trip_flag_event_postbooking3h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING24H = 'tour_participant.trip_flag_event_postbooking24h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING48H = 'tour_participant.trip_flag_event_postbooking48h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ENDTRIP1H = 'tour_participant.trip_flag_event_endtrip1h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ENDTRIP24H = 'tour_participant.trip_flag_event_endtrip24h';
export const TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ENDTRIP48H = 'tour_participant.trip_flag_event_endtrip48h';
export const TOUR_PARTICIPANT_ABANDONED_CART = 'tour_participant.trip_flag_event_abandoned_cart';
// export const TOUR_PARTICIPANT_DATE_CHANGED = "tour_participant.date_changed";
export const TOUR_DEPARTURE_24H = 'tour_departure.24h';
export const TOUR_DEPARTURE_1H = 'tour_departure.1h';
export const TOUR_DEPARTURE_10D = 'tour_departure.10d';
export const TOUR_DEPARTURE_9D = 'tour_departure.9d';
export const TOUR_DEPARTURE_7D = 'tour_departure.7d';
export const TOUR_DEPARTURE_5D = 'tour_departure.5d';
export const TOUR_DEPARTURE_72H = 'tour_departure.72h';
export const TOUR_DEPARTURE_48H = 'tour_departure.48h';
export const TOUR_DEPARTURE_16H = 'tour_departure.16h';
export const TOUR_DEPARTURE_135H = 'tour_departure.135h';
export const TOUR_DEPARTURE_12H = 'tour_departure.12h';
export const TOUR_DEPARTURE_115H = 'tour_departure.115h';
export const TOUR_DEPARTURE_2H = 'tour_departure.2h';
export const TOUR_DEPARTURE_30M = 'tour_departure.30m';
export const TOUR_DEPARTURE_5M = 'tour_departure.5m';
export const TOUR_DEPARTURE_POST20M = 'tour_departure.post20m';
export const TOUR_DEPARTURE_POST1H = 'tour_departure.post1h';
export const TOUR_DEPARTURE_POST12H = 'tour_departure.post12h';
export const TOUR_DEPARTURE_POST24H = 'tour_departure.post24h';
export const TOUR_DEPARTURE_POST36H = 'tour_departure.post36h';
export const TOUR_DEPARTURE_POST48H = 'tour_departure.post48h';
export const TOUR_DEPARTURE_POST72H = 'tour_departure.post72h';
export const TOUR_DEPARTURE_POST10D = 'tour_departure.post10d';
export const TOUR_DEPARTURE_POST29D = 'tour_departure.post29d';
export const TOUR_DEPARTURE_ONTRIP5M = 'tour_departure.ontrip5m';
export const TOUR_DEPARTURE_ONTRIP10M = 'tour_departure.ontrip10m';
export const TOUR_DEPARTURE_ONTRIP15M = 'tour_departure.ontrip15m';
export const TOUR_DEPARTURE_ONTRIP30H = 'tour_departure.ontrip30h';
export const TOUR_DEPARTURE_ONTRIP45M = 'tour_departure.ontrip45m';
export const TOUR_DEPARTURE_ONTRIP45H = 'tour_departure.ontrip45h';
export const TOUR_DEPARTURE_ENDTRIP1H = 'tour_departure.endtrip1h';
export const TOUR_DEPARTURE_ENDTRIP24H = 'tour_departure.endtrip24h';
export const TOUR_DEPARTURE_ENDTRIP48H = 'tour_departure.endtrip48h';

export const DEPARTURE_24H = 'departure.24h';
export const DEPARTURE_1H = 'departure.1h';
export const DEPARTURE_10D = 'departure.10d';
export const DEPARTURE_9D = 'departure.9d';
export const DEPARTURE_7D = 'departure.7d';
export const DEPARTURE_5D = 'departure.5d';
export const DEPARTURE_72H = 'departure.72h';
export const DEPARTURE_48H = 'departure.48h';
export const DEPARTURE_16H = 'departure.16h';
export const DEPARTURE_135H = 'departure.135h';
export const DEPARTURE_12H = 'departure.12h';
export const DEPARTURE_115H = 'departure.115h';
export const DEPARTURE_2H = 'departure.2h';
export const DEPARTURE_30M = 'departure.30m';
export const DEPARTURE_5M = 'departure.5m';
export const DEPARTURE_POST20M = 'departure.post20m';
export const DEPARTURE_POST1H = 'departure.post1h';
export const DEPARTURE_POST12H = 'departure.post12h';
export const DEPARTURE_POST24H = 'departure.post24h';
export const DEPARTURE_POST36H = 'departure.post36h';
export const DEPARTURE_POST48H = 'departure.post48h';
export const DEPARTURE_ONTRIP10M = 'departure.ontrip10m';
export const DEPARTURE_ONTRIP45M = 'departure.ontrip45m';
export const DEPARTURE_ONTRIP45H = 'departure.ontrip45h';
export const DEPARTURE_ENDTRIP1H = 'departure.endtrip1h';
export const DEPARTURE_ENDTRIP24H = 'departure.endtrip24h';
export const DEPARTURE_ENDTRIP48H = 'departure.endtrip48h';

export const USER_DEPARTURE_24H = 'user_departure.24h';
export const USER_DEPARTURE_1H = 'user_departure.1h';
export const USER_DEPARTURE_10D = 'user_departure.10d';
export const USER_DEPARTURE_9D = 'user_departure.9d';
export const USER_DEPARTURE_7D = 'user_departure.7d';
export const USER_DEPARTURE_5D = 'user_departure.5d';
export const USER_DEPARTURE_72H = 'user_departure.72h';
export const USER_DEPARTURE_48H = 'user_departure.48h';
export const USER_DEPARTURE_16H = 'user_departure.16h';
export const USER_DEPARTURE_135H = 'user_departure.135h';
export const USER_DEPARTURE_12H = 'user_departure.12h';
export const USER_DEPARTURE_115H = 'user_departure.115h';
export const USER_DEPARTURE_2H = 'user_departure.2h';
export const USER_DEPARTURE_30M = 'user_departure.30m';
export const USER_DEPARTURE_5M = 'user_departure.5m';
export const USER_DEPARTURE_POST20M = 'user_departure.post20m';
export const USER_DEPARTURE_POST1H = 'user_departure.post1h';
export const USER_DEPARTURE_POST12H = 'user_departure.post12h';
export const USER_DEPARTURE_POST24H = 'user_departure.post24h';
export const USER_DEPARTURE_POST36H = 'user_departure.post36h';
export const USER_DEPARTURE_POST48H = 'user_departure.post48h';
export const USER_DEPARTURE_POST72H = 'user_departure.post72h';
export const USER_DEPARTURE_ONTRIP5M = 'user_departure.ontrip5m';
export const USER_DEPARTURE_ONTRIP10M = 'user_departure.ontrip10m';
export const USER_DEPARTURE_ONTRIP15M = 'user_departure.ontrip15m';
export const USER_DEPARTURE_ONTRIP3H = 'user_departure.ontrip3h';
export const USER_DEPARTURE_ONTRIP45M = 'user_departure.ontrip45m';
export const USER_DEPARTURE_ONTRIP45H = 'user_departure.ontrip45h';
export const USER_DEPARTURE_ENDTRIP1H = 'user_departure.endtrip1h';
export const USER_DEPARTURE_ENDTRIP24H = 'user_departure.endtrip24h';
export const USER_DEPARTURE_ENDTRIP48H = 'user_departure.endtrip48h';
export const USER_MESSAGE_RECEIVED = 'user.message_received';
export const USER_RECENT_MESSAGES_NOTIFICATION = 'user.recent_messages_notification';
export const USER_UNREAD_NOTIFICATION = 'user.unread_notification';
export const USER_CHATBOT_HANDOFF = 'user.chatbot_handoff';
export const USER_WEB_WIDGET_CONTACT_CAPTURED = 'user.web_widget_contact_captured';
export const TOUR_PARTICIPANT_SURVEY = 'tour_participant.survey';
export const TOUR_PARTICIPANT_REVIEW_SUBMITTED = 'tour_participant.review_submitted';

EVENTS[USER_MAGIC_LINK] = 'User requests magic link to log in';
EVENTS[USER_APP_DOWNLOADED] = 'User downloads the app';

EVENTS[TOUR_PARTICIPANT_CREATED] = 'User is added to a tour';
EVENTS[TOUR_PARTICIPANT_UPDATED] = "User's tour is updated";
EVENTS[TOUR_PARTICIPANT_DELETED] = "User's tour is cancelled";
EVENTS[BOOKING_PRECHECKIN_COMPLETED] = 'User has completed pre-checkin for a booking';
EVENTS[ORDER_CREATED] = "Order created";
EVENTS[ORDER_UPDATED] = "Order updated";
EVENTS[ORDER_PRETRIP_0M] = "Order: first trip has begun"
EVENTS[ORDER_PRETRIP_5M] = "Order: 5m before first trip"
EVENTS[ORDER_PRETRIP_30M] = "Order: 30m before first trip"
EVENTS[ORDER_PRETRIP_70M] = "Order: 70m before first trip"
EVENTS[ORDER_PRETRIP_1H] = "Order: 1h before first trip"
EVENTS[ORDER_PRETRIP_2H] = "Order: 2h before first trip"
EVENTS[ORDER_PRETRIP_115H] = "Order: 11.5h before first trip"
EVENTS[ORDER_PRETRIP_12H] = "Order: 12h before first trip"
EVENTS[ORDER_PRETRIP_135H] = "Order: 135h before first trip"
EVENTS[ORDER_PRETRIP_16H] = "Order: 16h before first trip"
EVENTS[ORDER_PRETRIP_20H] = "Order: 20h before first trip"
EVENTS[ORDER_PRETRIP_24H] = "Order: 24h before first trip"
EVENTS[ORDER_PRETRIP_48H] = "Order: 48h before first trip"
EVENTS[ORDER_PRETRIP_72H] = "Order: 72h before first trip"
EVENTS[ORDER_PRETRIP_5D] = "Order: 5d before first trip"
EVENTS[ORDER_PRETRIP_7D] = "Order: 7d before first trip"
EVENTS[ORDER_PRETRIP_9D] = "Order: 9d before first trip"
EVENTS[ORDER_PRETRIP_10D] = "Order: 10d before first trip"
EVENTS[ORDER_PRETRIP_14D] = "Order: 14d before first trip"
EVENTS[ORDER_PRETRIP_30D] = "Order: 30d before first trip"
EVENTS[ORDER_ONTRIP_5M] = "Order: first trip has begun 5 minutes ago"
EVENTS[ORDER_ONTRIP_10M] = "Order: first trip has begun 10 minutes ago"
EVENTS[ORDER_ONTRIP_15M] = "Order: first trip has begun 15 minutes ago"
EVENTS[ORDER_ONTRIP_45M] = "Order: first trip has begun 45 minutes ago"
EVENTS[ORDER_ONTRIP_3H] = "Order: first trip has begun 3 hours ago"
EVENTS[ORDER_ONTRIP_4H] = "Order: first trip has begun 4 hours ago"
EVENTS[ORDER_ONTRIP_45H] = "Order: first trip has begun 4.5 hours ago"
EVENTS[ORDER_ONTRIP_6H] = "Order: first trip has begun 6 hours ago"
EVENTS[ORDER_ONTRIP_8H] = "Order: first trip has begun 8 hours ago"
EVENTS[ORDER_ONTRIP_10H] = "Order: first trip has begun 10 hours ago"
EVENTS[ORDER_ONTRIP_24H] = "Order: first trip has begun 24 hours ago"
EVENTS[ORDER_ENDTRIP_1H] = "Order: last trip ends in 1 hour"
EVENTS[ORDER_ENDTRIP_24H] = "Order: last trip ends in 24 hours"
EVENTS[ORDER_ENDTRIP_48H] = "Order: last trip ends in 48 hours"
EVENTS[ORDER_POST_20M] = "Order: last trip ended 20 minutes ago"
EVENTS[ORDER_POST_1H] = "Order: last trip ended 1 hour ago"
EVENTS[ORDER_POST_2H] = "Order: last trip ended 2 hours ago"
EVENTS[ORDER_POST_12H] = "Order: last trip ended 12 hours ago"
EVENTS[ORDER_POST_24H] = "Order: last trip ended 24 hours ago"
EVENTS[ORDER_POST_36H] = "Order: last trip ended 36 hours ago"
EVENTS[ORDER_POST_48H] = "Order: last trip ended 48 hours ago"
EVENTS[ORDER_POST_72H] = "Order: last trip ended 72 hours ago"
EVENTS[ORDER_POST_10D] = "Order: last trip ended 10 days ago"
EVENTS[ORDER_POST_29D] = "Order: last trip ended 29 days ago"
EVENTS[ORDER_POST_1Y] = "Order: last trip ended 1 year ago"

EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_30D] = "User's tour begins in 30 days";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_14D] = "User's tour begins in 14 days";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_10D] = "User's tour begins in 10 days";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_9D] = "User's tour begins in 9 days";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_7D] = "User's tour begins in 7 days";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_5D] = "User's tour begins in 5 days";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_72H] = "User's tour begins in 72 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_48H] = "User's tour begins in 48 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_START] = "User's tour begins in 24 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_20H] = "User's tour begins in 20 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_16H] = "User's tour begins in 16 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_135H] = "User's tour begins in 13.5 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_12H] = "User's tour begins in 12 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_115H] = "User's tour begins in 11.5 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_2H] = "User's tour begins in 2 hrs";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_70M] = "User's tour begins in 70 minutes";
EVENTS[TOUR_PARTICIPANT_TRIP_ABOUT_TO_BEGIN] = "User's tour begins in 60 minutes";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_30M] = "User's tour begins in 30 minutes";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_5M] = "User's tour begins in 5 minutes";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_0M] = "User's tour has begun";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP5M] = "User's tour has begun 5 minutes ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP10M] = "User's tour has begun 10 minutes ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP15M] = "User's tour has begun 15 minutes ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP45M] = "User's tour has begun 45 minutes ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP3H] = "User's tour has begun 3 hours ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP4H] = "User's tour has begun 4 hours ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP45H] = "User's tour has begun 4.5 hours ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP6H] = "User's tour has begun 6 hours ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP8H] = "User's tour has begun 8 hours ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP10H] = "User's tour has begun 10 hours ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ONTRIP24H] = "User's tour has begun 24 hours ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING24H] = "User's tour was booked 24 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING48H] = "User's tour was booked 48 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ENDTRIP48H] = "User's tour ends in 48 hours";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ENDTRIP24H] = "User's tour ends in 24 hours";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_ENDTRIP1H] = "User's tour ends in 1 hour";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST20M] = "User's tour has ended 20 minutes ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST1H] = "User's tour has ended 1 hr ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST12H] = "User's tour has ended 12 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST24H] = "User's tour has ended 24 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST36H] = "User's tour has ended 36 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST48H] = "User's tour has ended 48 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST72H] = "User's tour has ended 72 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST10D] = "User's tour has ended 10 days ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST29D] = "User's tour has ended 29 days ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POST1Y] = "User's tour has ended 1 year ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING1H] = "User's tour was booked 1 hr ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING3H] = "User's tour was booked 3 hrs ago";
EVENTS[TOUR_PARTICIPANT_TRIP_FLAG_EVENT_POSTBOOKING24H] = "User's tour was booked 24 hrs ago";

EVENTS[TOUR_DEPARTURE_10D] = "Tour departure is in 10d";
EVENTS[TOUR_DEPARTURE_9D] = "Tour departure is in 9d";
EVENTS[TOUR_DEPARTURE_7D] = "Tour departure is in 7d";
EVENTS[TOUR_DEPARTURE_5D] = "Tour departure is in 5d";
EVENTS[TOUR_DEPARTURE_72H] = "Tour departure is in 72h";
EVENTS[TOUR_DEPARTURE_48H] = "Tour departure is in 48h";
EVENTS[TOUR_DEPARTURE_24H] = "Tour departure is in 24h";
EVENTS[TOUR_DEPARTURE_16H] = "Tour departure is in 16h";
EVENTS[TOUR_DEPARTURE_135H] = "Tour departure is in 13.5h";
EVENTS[TOUR_DEPARTURE_12H] = "Tour departure is in 12h";
EVENTS[TOUR_DEPARTURE_115H] = "Tour departure is in 11.5h";
EVENTS[TOUR_DEPARTURE_2H] = "Tour departure is in 2h";
EVENTS[TOUR_DEPARTURE_1H] = "Tour departure is in 1h";
EVENTS[TOUR_DEPARTURE_30M] = "Tour departure is in 30m";
EVENTS[TOUR_DEPARTURE_5M] = "Tour departure is in 5m";
EVENTS[TOUR_DEPARTURE_ONTRIP5M] = "Tour departure was 5 m ago";
EVENTS[TOUR_DEPARTURE_ONTRIP10M] = "Tour departure was 10 m ago";
EVENTS[TOUR_DEPARTURE_ONTRIP15M] = "Tour departure was 15 m ago";
EVENTS[TOUR_DEPARTURE_ONTRIP45M] = "Tour departure was 45 m ago";
EVENTS[TOUR_DEPARTURE_ONTRIP45H] = "Tour departure was 4.5 h ago";
EVENTS[TOUR_DEPARTURE_ENDTRIP48H] = "Tour departure - trip ends in 48 h";
EVENTS[TOUR_DEPARTURE_ENDTRIP24H] = "Tour departure - trip ends in 24 h";
EVENTS[TOUR_DEPARTURE_ENDTRIP1H] = "Tour departure - trip ends in 1 h";
EVENTS[TOUR_DEPARTURE_POST20M] = "Tour departure - trip ended 20m ago";
EVENTS[TOUR_DEPARTURE_POST1H] = "Tour departure - trip ended 1h ago";
EVENTS[TOUR_DEPARTURE_POST12H] = "Tour departure - trip ended 12h ago";
EVENTS[TOUR_DEPARTURE_POST24H] = "Tour departure - trip ended 24h ago";
EVENTS[TOUR_DEPARTURE_POST36H] = "Tour departure - trip ended 36h ago";
EVENTS[TOUR_DEPARTURE_POST48H] = "Tour departure - trip ended 48h ago";
EVENTS[TOUR_DEPARTURE_POST72H] = "Tour departure - trip ended 72h ago";
EVENTS[TOUR_DEPARTURE_POST10D] = "Tour departure - trip ended 10d ago";
EVENTS[TOUR_DEPARTURE_POST29D] = "Tour departure - trip ended 29d ago";

// EVENTS[DEPARTURE_9D] = "Multitour departure is in 9d"
// EVENTS[DEPARTURE_7D] = "Multitour departure is in 7d"
// EVENTS[DEPARTURE_72H] = "Multitour departure is in 72h"
// EVENTS[DEPARTURE_48H] = "Multitour departure is in 48h"
// EVENTS[DEPARTURE_16H] = "Multitour departure is in 16h"
// EVENTS[DEPARTURE_135H] = "Multitour departure is in 13.5h"
// EVENTS[DEPARTURE_115H] = "Multitour departure is in 11.5h"
// EVENTS[DEPARTURE_24H] = "Multitour departure is in 24h"
// EVENTS[DEPARTURE_12H] = "Multitour departure is in 12h"
// EVENTS[DEPARTURE_2H] = "Multitour departure is in 2h"
// EVENTS[DEPARTURE_1H] = "Multitour departure is in 1h"
// EVENTS[DEPARTURE_30M] = "Multitour departure is in 30m"
// EVENTS[DEPARTURE_5M] = "Multitour departure is in 5m"
// EVENTS[DEPARTURE_ONTRIP45M] = "Multitour departure was 45 m ago"
// EVENTS[DEPARTURE_ONTRIP45H] = "Multitour departure was 4.5 h ago"
// EVENTS[DEPARTURE_ENDTRIP24H] = "Multitour departure - trip ends in 24 h"
// EVENTS[DEPARTURE_ENDTRIP1H] = "Multitour departure - trip ends in 1 h"
// EVENTS[DEPARTURE_POST1H] = "Multitour departure - trip ended 1 h ago"
// EVENTS[DEPARTURE_POST24H] = "Multitour departure - trip ended 24 h ago"
// EVENTS[DEPARTURE_POST36H] = "Multitour departure - trip ended 36 h ago"
// EVENTS[DEPARTURE_POST48H] = "Multitour departure - trip ended 48 h ago"

EVENTS[USER_DEPARTURE_10D] = "User has departures in 10 days";
EVENTS[USER_DEPARTURE_9D] = "User has departures in 9 days";
EVENTS[USER_DEPARTURE_7D] = "User has departures in 7 days";
EVENTS[USER_DEPARTURE_5D] = "User has departures in 5 days";
EVENTS[USER_DEPARTURE_72H] = "User has departures in 72 hrs";
EVENTS[USER_DEPARTURE_48H] = "User has departures in 48 hrs";
EVENTS[USER_DEPARTURE_24H] = "User has departures in 24 hrs";
EVENTS[USER_DEPARTURE_16H] = "User has departures in 16 hrs";
EVENTS[USER_DEPARTURE_135H] = "User has departures in 13.5 hrs";
EVENTS[USER_DEPARTURE_12H] = "User has departures in 12 hrs";
EVENTS[USER_DEPARTURE_115H] = "User has depatures in 11.5 hrs";
EVENTS[USER_DEPARTURE_2H] = "User has departures in 2 hrs";
EVENTS[USER_DEPARTURE_1H] = "User has departures in 1 hr";
EVENTS[USER_DEPARTURE_30M] = "User has departures in 30 minutes";
EVENTS[USER_DEPARTURE_5M] = "User has departures in 5 minutes";
EVENTS[USER_DEPARTURE_ONTRIP5M] = "User has departures that started 5 minutes ago";
EVENTS[USER_DEPARTURE_ONTRIP10M] = "User has departures that started 10 minutes ago";
EVENTS[USER_DEPARTURE_ONTRIP15M] = "User has departures that started 15 minutes ago";
EVENTS[USER_DEPARTURE_ONTRIP45M] = "User has departures that started 45 minutes ago";
EVENTS[USER_DEPARTURE_ONTRIP3H] = "User has departures that started 3 hours ago";
EVENTS[USER_DEPARTURE_ONTRIP45H] = "User has departures that started 4.5 hours ago";
EVENTS[USER_DEPARTURE_ENDTRIP48H] = "User has departures that end in 48 hours";
EVENTS[USER_DEPARTURE_ENDTRIP24H] = "User has departures that end in 24 hours";
EVENTS[USER_DEPARTURE_ENDTRIP1H] = "User has departures that end in 1 hour";
EVENTS[USER_DEPARTURE_POST20M] = "User has departures that ended 20 minutes ago";
EVENTS[USER_DEPARTURE_POST1H] = "User has departures that ended 1 hr ago";
EVENTS[USER_DEPARTURE_POST12H] = "User has departures that ended 12 hrs ago";
EVENTS[USER_DEPARTURE_POST24H] = "User has departures that ended 24 hrs ago";
EVENTS[USER_DEPARTURE_POST36H] = "User has departures that ended 36 hrs ago";
EVENTS[USER_DEPARTURE_POST48H] = "User has departures that ended 48 hrs ago";
EVENTS[USER_DEPARTURE_POST72H] = "User has departures that ended 72 hrs ago";
// EVENTS[TOUR_PARTICIPANT_DATE_CHANGED] = "User's tour date/time changes";
EVENTS[USER_MESSAGE_RECEIVED] = 'User receives a message';
EVENTS[USER_RECENT_MESSAGES_NOTIFICATION] = 'User has recent messages';
EVENTS[USER_UNREAD_NOTIFICATION] = 'User has unread messages';
EVENTS[USER_CHATBOT_HANDOFF] = 'Chatbot hands a website visitor to the team';
EVENTS[USER_WEB_WIDGET_CONTACT_CAPTURED] = 'Website visitor left contact details for the team';
EVENTS[TOUR_PARTICIPANT_SURVEY] = "User's trip has ended";
EVENTS[TOUR_PARTICIPANT_REVIEW_SUBMITTED] = "User submitted a review";
EVENTS[TOUR_PARTICIPANT_ABANDONED_CART] = "Cart was abandoned X minutes ago";

export const eventOptions = Object.entries(EVENTS).map(([value, label]) => ({
    value,
    label,
}));

export const DELIVERY_METHODS: IntStringMap = {};
export const DELIVERY_METHOD_EMAIL = 0;
export const DELIVERY_METHOD_SMS = 1;
export const DELIVERY_METHOD_CHAT = 2;
// export const DELIVERY_METHOD_PUSH_NOTIFICATION = 3;
// export const DELIVERY_METHOD_SENTRY = 4;
// export const DELIVERY_METHOD_SNS_TOPIC = 5;
export const DELIVERY_METHOD_HTTP_REQUEST = 6;
export const DELIVERY_METHOD_WHATSAPP = 7;
export const DELIVERY_METHOD_AIRBNB = 8;
DELIVERY_METHODS[DELIVERY_METHOD_EMAIL] = 'Email';
DELIVERY_METHODS[DELIVERY_METHOD_SMS] = 'SMS';
DELIVERY_METHODS[DELIVERY_METHOD_WHATSAPP] = 'WhatsApp';
DELIVERY_METHODS[DELIVERY_METHOD_CHAT] = 'Chat';
// DELIVERY_METHODS[DELIVERY_METHOD_PUSH_NOTIFICATION] = 'Push Notification';
// DELIVERY_METHODS[DELIVERY_METHOD_SENTRY] = 'Sentry Alert';
// DELIVERY_METHODS[DELIVERY_METHOD_SNS_TOPIC] = 'AWS SNS';
DELIVERY_METHODS[DELIVERY_METHOD_HTTP_REQUEST] = 'HTTP Request';
DELIVERY_METHODS[DELIVERY_METHOD_AIRBNB] = 'Airbnb';
// The delivery methods a non-admin sees in a notification's Delivery table. Every method the
// "Select delivery method" picker offers must be here: a method missing from this list is still
// added and saved, but the row never shows, so it can't be configured or removed (Babylon's
// HTTP Request rows, 2026-10-24).
export const NON_ADMIN_DELIVERY_METHODS = [0, 1, 2, 6, 7, 8];

export const OPS: IntStringMap = {};
export const OP_EQ = 0;
export const OP_GT = 1;
export const OP_GTE = 2;
export const OP_LT = 3;
export const OP_LTE = 4;
export const OP_CONTAINS = 5;
export const OP_TRUE = 6;
export const OP_FALSE = 7;
OPS[OP_EQ] = ' == ';
OPS[OP_GT] = ' > ';
OPS[OP_GTE] = ' >= ';
OPS[OP_LT] = ' < ';
OPS[OP_LTE] = ' <= ';
OPS[OP_CONTAINS] = 'Contains';
OPS[OP_TRUE] = 'Is True';
OPS[OP_FALSE] = 'Is False';

export const DELIVERY_ORDERING: IntStringMap = {};
export const DELIVERY_ALL = 0;
export const DELIVERY_FIRST = 1;
export const DELIVERY_ADVANCED = 2;
DELIVERY_ORDERING[DELIVERY_ALL] = 'Use all delivery methods';
DELIVERY_ORDERING[DELIVERY_FIRST] = 'Stop at first successful';
DELIVERY_ORDERING[DELIVERY_ADVANCED] = 'Advanced Settings';

export const RULES_MATCH_TYPES: IntStringMap = {};
export const RULES_MATCH_ALL = 0;
export const RULES_MATCH_ANY = 1;
RULES_MATCH_TYPES[RULES_MATCH_ALL] = 'Match all rules';
RULES_MATCH_TYPES[RULES_MATCH_ANY] = 'Match any rule';


export const DELIVERY_METHOD_EMAIL_DESTINATION: IntStringMap = {};
export const EMAIL_TO_USER = 0;
export const EMAIL_TO_SUPPORT = 1;
export const EMAIL_TO_ADDRESS = 2;
export const EMAIL_TO_TC_ALL = 3;
export const EMAIL_TO_TC_STAFF = 4;
export const EMAIL_TO_TC_GUIDES = 5;
export const EMAIL_TO_TC_ADMINS = 6;
export const EMAIL_TO_TC_GUESTS = 7;
export const EMAIL_TO_OTA_CONTACT = 8;
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_USER] = 'User';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_SUPPORT] = 'Support';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_ADDRESS] = 'Email Address';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_TC_ALL] = 'All conversation members';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_TC_STAFF] = 'Staff in conversation';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_TC_GUIDES] = 'Guides in conversation';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_TC_ADMINS] = 'Admins in conversation';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_TC_GUESTS] = 'Guests in conversation';
DELIVERY_METHOD_EMAIL_DESTINATION[EMAIL_TO_OTA_CONTACT] = 'OTA contact';

export const DELIVERY_METHOD_SMS_DESTINATION: IntStringMap = {};
export const SMS_TO_USER = 0;
export const SMS_TO_SUPPORT = 1;
export const SMS_TO_NUMBER = 2;
export const SMS_TO_TC_ALL = 3;
export const SMS_TO_TC_STAFF = 4;
export const SMS_TO_TC_GUIDES = 5;
export const SMS_TO_TC_ADMINS = 6;
export const SMS_TO_TC_GUESTS = 7;
export const SMS_TO_OTA_CONTACT = 8;
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_USER] = 'User';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_SUPPORT] = 'Support';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_NUMBER] = 'Phone Number';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_TC_ALL] = 'All Conversation Members';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_TC_STAFF] = 'Staff Conversation Members';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_TC_GUIDES] = 'Guides in Conversation';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_TC_ADMINS] = 'Admins in Conversation';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_TC_GUESTS] = 'Guests in Conversation';
DELIVERY_METHOD_SMS_DESTINATION[SMS_TO_OTA_CONTACT] = 'OTA contact';

export const DELIVERY_METHOD_WHATSAPP_DESTINATION: IntStringMap = {};
export const WHATSAPP_TO_USER = 0;
export const WHATSAPP_TO_SUPPORT = 1;
export const WHATSAPP_TO_NUMBER = 2;
export const WHATSAPP_TO_TC_ALL = 3;
export const WHATSAPP_TO_TC_STAFF = 4;
export const WHATSAPP_TO_TC_GUIDES = 5;
export const WHATSAPP_TO_TC_ADMINS = 6;
export const WHATSAPP_TO_TC_GUESTS = 7;
export const WHATSAPP_TO_OTA_CONTACT = 8;
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_USER] = 'User';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_SUPPORT] = 'Support';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_NUMBER] = 'Phone Number';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_TC_ALL] = 'All Conversation Members';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_TC_STAFF] = 'Staff Conversation Members';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_TC_GUIDES] = 'Guides in Conversation';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_TC_ADMINS] = 'Admins in Conversation';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_TC_GUESTS] = 'Guests in Conversation';
DELIVERY_METHOD_WHATSAPP_DESTINATION[WHATSAPP_TO_OTA_CONTACT] = 'OTA contact';

export const DELIVERY_METHOD_AIRBNB_DESTINATION: IntStringMap = {};
export const AIRBNB_TO_SPECIFIC_TOUR = 0;
export const AIRBNB_TO_ARBITRARY_THREAD_ID = 1;
DELIVERY_METHOD_AIRBNB_DESTINATION[AIRBNB_TO_SPECIFIC_TOUR] = "User's Tour";
DELIVERY_METHOD_AIRBNB_DESTINATION[AIRBNB_TO_ARBITRARY_THREAD_ID] = "Arbitrary Airbnb Thread";


export const DELIVERY_METHOD_CHAT_DESTINATION: IntStringMap = {};
export const CHAT_TO_MAIN_OFFICE = 0;
// export const CHAT_TO_ACTIVE_TOUR = 1;
export const CHAT_TO_CONVERSATION = 2;
// export const CHAT_TO_ARBITRARY_SID = 3;
export const CHAT_TO_GROUP_CHAT = 4;
export const CHAT_TO_INTERNAL_CHAT = 5;
export const CHAT_TO_ANNOUNCEMENTS = 6;
DELIVERY_METHOD_CHAT_DESTINATION[CHAT_TO_MAIN_OFFICE] = 'Main Office';
// DELIVERY_METHOD_CHAT_DESTINATION[CHAT_TO_ACTIVE_TOUR] = "Active Tour";
DELIVERY_METHOD_CHAT_DESTINATION[CHAT_TO_CONVERSATION] = "User's Tour";
// DELIVERY_METHOD_CHAT_DESTINATION[CHAT_TO_ARBITRARY_SID] = "Arbitrary Conversation";
DELIVERY_METHOD_CHAT_DESTINATION[CHAT_TO_GROUP_CHAT] = "Group Chat";
DELIVERY_METHOD_CHAT_DESTINATION[CHAT_TO_INTERNAL_CHAT] = "Internal Chat";
DELIVERY_METHOD_CHAT_DESTINATION[CHAT_TO_ANNOUNCEMENTS] = "Announcements";

export const DELIVERY_METHOD_CHAT_ORIGIN: IntStringMap = {};
export const CHAT_AUTOMATED_MESSAGE = 0;
export const CHAT_USER = 1;
DELIVERY_METHOD_CHAT_ORIGIN[CHAT_AUTOMATED_MESSAGE] = 'Automated message';
DELIVERY_METHOD_CHAT_ORIGIN[CHAT_USER] = 'User';

export const HTTP_METHODS: StringStringMap = {};
export const HTTP_METHOD_GET = "GET";
export const HTTP_METHOD_HEAD = "HEAD";
export const HTTP_METHOD_POST = "POST";
export const HTTP_METHOD_PUT = "PUT";
export const HTTP_METHOD_PATCH = "PATCH";
export const HTTP_METHOD_DELETE = "DELETE";
HTTP_METHODS[HTTP_METHOD_GET] = "GET";
HTTP_METHODS[HTTP_METHOD_HEAD] = "HEAD";
HTTP_METHODS[HTTP_METHOD_POST] = "POST";
HTTP_METHODS[HTTP_METHOD_PUT] = "PUT";
HTTP_METHODS[HTTP_METHOD_PATCH] = "PATCH";
HTTP_METHODS[HTTP_METHOD_DELETE] = "DELETE";

export const httpMethodOptions = genOptions(HTTP_METHODS);
export const httpMethodHtmlOptions = genHtmlOptions(HTTP_METHODS);
export const httpMethodMenuItems = genMenuItems(HTTP_METHODS);

export const TOUR_OVERRIDE_MODES: IntStringMap = {};
export const TOUR_OVERRIDE_MODE_NONOVERRIDABLE = 0; //Default
export const TOUR_OVERRIDE_MODE_OVERRIDABLE = 1;
export const TOUR_OVERRIDE_MODE_OVERRIDE = 2; //Tour specific

//If user selects Defaults these options will be available
TOUR_OVERRIDE_MODES[TOUR_OVERRIDE_MODE_NONOVERRIDABLE] = 'Non overridable - Will be sent to all tours';
TOUR_OVERRIDE_MODES[TOUR_OVERRIDE_MODE_OVERRIDABLE] = 'Overridable - Will be sent to all tours except the ones that have the same tour-specific notification';
TOUR_OVERRIDE_MODES[TOUR_OVERRIDE_MODE_OVERRIDE] = 'Tour Specific (sent to just one tour)';

export const NOTIFICATION_REACTIONS: IntStringMap = {};
export const USER_STAYS_OFFLINE = 0;
export const USER_DOESNT_INSTALL_APP = 1;
export const USER_DOESNT_SHARE_LOCATION = 2;
export const USER_DOESNT_ENABLE_NOTIFICATIONS = 3;
NOTIFICATION_REACTIONS[USER_STAYS_OFFLINE] = 'User stays offline';
NOTIFICATION_REACTIONS[USER_DOESNT_INSTALL_APP] = "User doesn't install the app";
NOTIFICATION_REACTIONS[USER_DOESNT_SHARE_LOCATION] = "User doesn't share location";
NOTIFICATION_REACTIONS[USER_DOESNT_ENABLE_NOTIFICATIONS] = "User doesn't enable notifications";

export const NOTIFICATION_RULE_TEMPLATES: IntStringMap = {};

export const USER_HAS_APP_INSTALLED = 0;
export const TOUR_PARTICIPANT_USED_SELF_REGISTRATION_LINK = 1;
export const TOUR_PARTICIPANT_USED_TRIP_CODE = 2;
export const TOUR_PARTICIPANT_ADDED_VIA_DASHBOARD = 3;
export const TOUR_PARTICIPANT_HAS_A_STAFF_ROLE = 4;
export const USER_HAS_IOS_APP = 5;
export const USER_HAS_ANDROID_APP = 6;
export const USER_LOGGED_IN = 7;
export const USER_COUNTRY = 8;
export const USER_LANGUAGE = 9;
export const USER_REGISTERED_VIA_OTA = 10;
export const USER_HAS_LOCATION_SHARING_ENABLED = 11;
export const MESSAGE_IS_TO_USER_OR_IS_ANNOUNCEMENT = 12;
export const MESSAGE_IS_TO_GROUP_CHAT = 13;
export const MESSAGE_IS_TO_INTERNAL_STAFF_GUIDES_CHAT = 14;
export const USER_HAS_PUSH_NOTIFICATIONS_ENABLED = 15;
export const RECEIVED_MESSAGE_IS_AUTOMATED = 16;
export const TOUR_PARTICIPANT_CHECKED_IN = 17;
export const TOUR_PARTICIPANT_DIDNT_SHOW_UP = 18;
export const PASSENGER_COUNT_MODIFIED = 19;
export const RECEIVED_MESSAGE_IS_TO_MAIN_OFFICE = 20;
export const TOUR_PARTICIPANT_IS_CREATED_VIA_INTEGRATION = 21;
export const TOUR_PARTICIPANT_IS_CREATED_VIA_XML = 22;
export const TOUR_PARTICIPANT_IS_CREATED_VIA_DASHBOARD = 23;
export const TOUR_PARTICIPANT_IS_CREATED_VIA_TRIP_CODE = 24;
export const TOUR_PARTICIPANT_IS_CREATED_FROM_TAG = 25;
export const TOUR_PARTICIPANT_IS_UPDATED_VIA_INTEGRATION = 26;
export const TOUR_PARTICIPANT_IS_UPDATED_VIA_XML = 27;
export const TOUR_PARTICIPANT_IS_UPDATED_VIA_DASHBOARD = 28;
export const TOUR_PARTICIPANT_IS_UPDATED_VIA_SELFREG_PAGE = 29;
export const TOUR_PARTICIPANT_IS_UPDATED_VIA_TRIP_CODE = 30;
export const TOUR_PARTICIPANT_IS_FIELD_AFFECTED = 31;
export const TOUR_PARTICIPANT_IS_UPDATED_VIA = 32
export const TOUR_PARTICIPANT_HAS_TAG_CATEGORY = 33;
export const TOUR_PARTICIPANT_HAS_TAG = 34;
export const TOUR_PARTICIPANT_SURVEY_STATE = 35;
export const USER_HAS_NO_CONTACT_INFO = 36;
export const BOOKING_IS_REBOOKING = 37;
export const TOUR_PARTICIPANT_FIELD_EXISTS = 38;
export const TRIP_BEGINS_WITHIN_X_TIME = 39;
export const REVIEW_IS_POSITIVE_NEGATIVE = 40;
export const USER_ENTERS_LOCATION_RADIUS = 41;
export const BOOKING_DATETIME_IS_WITHIN_RANGE = 42;
export const PHONE_COUNTRY = 43;
export const REVIEW_RATING = 44;
export const USER_HAS_OTHER_TOURS = 45;
export const MESSAGE_IS_TO_USER = 46;
export const MESSAGE_IS_ANNOUNCEMENT = 47;
export const INCLUDE_RULESET = 48;
export const EVENT_TYPE = 49;
export const TOUR_HAS_TAG_CATEGORY = 50;
export const TOUR_HAS_TAG = 51;
export const OTA_HAS_TAG_CATEGORY = 52;
export const OTA_HAS_TAG = 53;
export const TOUR_OPERATOR_HAS_TAG_CATEGORY = 54;
export const TOUR_OPERATOR_HAS_TAG = 55;
export const TPL_DELIVERY_METHOD = 56;
export const TPL_IS_MAIN_BOOKING = 57;
export const TPL_CHECKIN_SOURCE = 58;
export const TPL_TRIP_TIME_RANGE = 59;
export const TPL_PRECHECKIN_STATUS = 60;
export const TPL_EMAIL_RECEIPT = 61;
export const TPL_SETTLEMENT_METHOD = 62;
export const TPL_ORDER_HAS_BOOKINGS = 63;
export const TPL_MARKETING_CONSENT_GRANTED = 64;
export const TPL_PRIVACY_POLICY_ACCEPTED = 65;
export const TPL_HAS_SUBBOOKINGS = 66;
export const DATETIME_WITHIN_RANGE = 67;
export const DATE_WITHIN_RANGE = 68;
export const TIME_WITHIN_RANGE = 69;
export const HAS_REAL_GUEST_NAMES = 70;
// CP-8095. TOUR_PARTICIPANT_HAS_TAG* (33/34) are the booking-level conditions;
// these are the order-level and user-ACCOUNT-level ones and need no participant.
export const ORDER_HAS_TAG_CATEGORY = 71;
export const ORDER_HAS_TAG = 72;
export const ACCOUNT_HAS_TAG_CATEGORY = 73;
export const ACCOUNT_HAS_TAG = 74;
// CP-8136. Matches every thread of a guide-group (staff chat group) channel;
// backend Notification_Rule.TPL_IS_STAFF_CHAT_GROUP.
export const TPL_IS_STAFF_CHAT_GROUP = 75;

export const DT_RANGE_COMPARISONS = [
    { value: 'any_between',  label: 'any value is between' },
    { value: 'all_between',  label: 'all values are between' },
    { value: 'any_gt',       label: 'any value is greater than' },
    { value: 'all_gt',       label: 'all values are greater than' },
    { value: 'any_gte',      label: 'any value is greater than or equal to' },
    { value: 'all_gte',      label: 'all values are greater than or equal to' },
    { value: 'any_lt',       label: 'any value is less than' },
    { value: 'all_lt',       label: 'all values are less than' },
    { value: 'any_lte',      label: 'any value is less than or equal to' },
    { value: 'all_lte',      label: 'all values are less than or equal to' },
];

NOTIFICATION_RULE_TEMPLATES[USER_HAS_APP_INSTALLED] = 'User has app installed';
// 2023-06-09 the 3 rules below are deprecated
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_USED_SELF_REGISTRATION_LINK] = 'Tour participant used self-registration link';
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_USED_TRIP_CODE] = 'Tour participant used trip code';
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_ADDED_VIA_DASHBOARD] = 'Tour participant added via dashboard';
// 2023-06-12 the 3 rules below are confusing the DET (#CP-3681)
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_CREATED_VIA_INTEGRATION] = "Tour participant was created by an integration";
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_CREATED_VIA_XML] = "Tour participant was imported from XML";
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_CREATED_VIA_DASHBOARD] = "Tour participant was added in the dashboard";
// 2023-06-13 more removals
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_CREATED_VIA_TRIP_CODE] = "Tour participant was added from a trip code";
// NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_CREATED_FROM_TAG] = "Tour participant was added from a tag";
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_UPDATED_VIA_INTEGRATION] = "Tour participant was updated by an integration";
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_UPDATED_VIA_XML] = "Tour participant was updated by XML import";
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_UPDATED_VIA_DASHBOARD] = "Tour participant was updated in the dashboard";
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_UPDATED_VIA_SELFREG_PAGE] = "Tour participant was updated at the self-registration page";
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_UPDATED_VIA_TRIP_CODE] = "Tour participant was updated via the trip code"
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_HAS_A_STAFF_ROLE] = 'Tour participant has a staff role';
NOTIFICATION_RULE_TEMPLATES[USER_HAS_IOS_APP] = 'User has iOS app';
NOTIFICATION_RULE_TEMPLATES[USER_HAS_ANDROID_APP] = 'User has Android app';
NOTIFICATION_RULE_TEMPLATES[USER_LOGGED_IN] = 'User logged in';
NOTIFICATION_RULE_TEMPLATES[USER_COUNTRY] = 'User country';
NOTIFICATION_RULE_TEMPLATES[PHONE_COUNTRY] = "User's phone country";
NOTIFICATION_RULE_TEMPLATES[USER_LANGUAGE] = 'User language';
NOTIFICATION_RULE_TEMPLATES[USER_REGISTERED_VIA_OTA] = 'User registered via OTA';
NOTIFICATION_RULE_TEMPLATES[USER_HAS_LOCATION_SHARING_ENABLED] = 'User has location sharing enabled';
NOTIFICATION_RULE_TEMPLATES[MESSAGE_IS_TO_USER] = 'Message is to a personal conversation';
NOTIFICATION_RULE_TEMPLATES[MESSAGE_IS_ANNOUNCEMENT] = 'Message is an announcement';
NOTIFICATION_RULE_TEMPLATES[MESSAGE_IS_TO_USER_OR_IS_ANNOUNCEMENT] = 'Message is to a personal conversation or is an announcement';
NOTIFICATION_RULE_TEMPLATES[MESSAGE_IS_TO_GROUP_CHAT] = 'Message is to group chat';
NOTIFICATION_RULE_TEMPLATES[MESSAGE_IS_TO_INTERNAL_STAFF_GUIDES_CHAT] = 'Message is to INTERNAL (guides/staff) chat';
NOTIFICATION_RULE_TEMPLATES[TPL_IS_STAFF_CHAT_GROUP] = 'Message is in a guide group';
NOTIFICATION_RULE_TEMPLATES[USER_HAS_PUSH_NOTIFICATIONS_ENABLED] = 'User has push notifications enabled';
NOTIFICATION_RULE_TEMPLATES[RECEIVED_MESSAGE_IS_AUTOMATED] = 'Received message is automated';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_CHECKED_IN] = 'Tour participant checked in';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_DIDNT_SHOW_UP] = "Tour participant didn't show up";
NOTIFICATION_RULE_TEMPLATES[PASSENGER_COUNT_MODIFIED] = 'Passenger count was modified';
NOTIFICATION_RULE_TEMPLATES[RECEIVED_MESSAGE_IS_TO_MAIN_OFFICE] = 'Received message is to Main Office/New Bookings';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_FIELD_AFFECTED] = 'Fields were affected by tour participant update';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_IS_UPDATED_VIA] = 'Tour participant updated via one of the methods';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_HAS_TAG_CATEGORY] = 'Tour participant has one of the tag categories';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_HAS_TAG] = 'Tour participant has one of the tags';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_SURVEY_STATE] = 'Tour participant survey state';
NOTIFICATION_RULE_TEMPLATES[USER_HAS_NO_CONTACT_INFO] = 'User has no direct contact info';
NOTIFICATION_RULE_TEMPLATES[BOOKING_IS_REBOOKING] = 'Booking was rebooked';
NOTIFICATION_RULE_TEMPLATES[TOUR_PARTICIPANT_FIELD_EXISTS] = 'Field exists and has value';
NOTIFICATION_RULE_TEMPLATES[TRIP_BEGINS_WITHIN_X_TIME] = 'Tour begins within X hours';
NOTIFICATION_RULE_TEMPLATES[REVIEW_IS_POSITIVE_NEGATIVE] = 'Review is positive/negative';
NOTIFICATION_RULE_TEMPLATES[REVIEW_RATING] = 'Review has rating';
NOTIFICATION_RULE_TEMPLATES[USER_ENTERS_LOCATION_RADIUS] = 'User enters location radius';
NOTIFICATION_RULE_TEMPLATES[BOOKING_DATETIME_IS_WITHIN_RANGE] = 'Booking time is within X hours';
NOTIFICATION_RULE_TEMPLATES[USER_HAS_OTHER_TOURS] = 'User has other tours';
NOTIFICATION_RULE_TEMPLATES[INCLUDE_RULESET] = 'Include ruleset';
NOTIFICATION_RULE_TEMPLATES[EVENT_TYPE] = 'Event type';
NOTIFICATION_RULE_TEMPLATES[TOUR_HAS_TAG_CATEGORY] = 'Tour has one of the tag categories';
NOTIFICATION_RULE_TEMPLATES[TOUR_HAS_TAG] = 'Tour has one of the tags';
NOTIFICATION_RULE_TEMPLATES[OTA_HAS_TAG_CATEGORY] = 'OTA has one of the tag categories';
NOTIFICATION_RULE_TEMPLATES[OTA_HAS_TAG] = 'OTA has one of the tags';
NOTIFICATION_RULE_TEMPLATES[TOUR_OPERATOR_HAS_TAG_CATEGORY] = 'Tour operator has one of the tag categories';
NOTIFICATION_RULE_TEMPLATES[TOUR_OPERATOR_HAS_TAG] = 'Tour operator has one of the tags';
NOTIFICATION_RULE_TEMPLATES[ORDER_HAS_TAG_CATEGORY] = 'Order has one of the tag categories';
NOTIFICATION_RULE_TEMPLATES[ORDER_HAS_TAG] = 'Order has one of the tags';
NOTIFICATION_RULE_TEMPLATES[ACCOUNT_HAS_TAG_CATEGORY] = 'User account has one of the tag categories';
NOTIFICATION_RULE_TEMPLATES[ACCOUNT_HAS_TAG] = 'User account has one of the tags';
NOTIFICATION_RULE_TEMPLATES[TPL_DELIVERY_METHOD] = 'Delivery method';
NOTIFICATION_RULE_TEMPLATES[TPL_IS_MAIN_BOOKING] = 'Tour participant is the main booker';
NOTIFICATION_RULE_TEMPLATES[TPL_CHECKIN_SOURCE] = 'Check-in source';
NOTIFICATION_RULE_TEMPLATES[TPL_TRIP_TIME_RANGE] = 'Trip time range';
NOTIFICATION_RULE_TEMPLATES[TPL_PRECHECKIN_STATUS] = 'Pre-check-in status';
NOTIFICATION_RULE_TEMPLATES[TPL_EMAIL_RECEIPT] = 'Email receipt';
NOTIFICATION_RULE_TEMPLATES[TPL_SETTLEMENT_METHOD] = 'Settlement method';
NOTIFICATION_RULE_TEMPLATES[TPL_ORDER_HAS_BOOKINGS] = 'Order has bookings';
NOTIFICATION_RULE_TEMPLATES[TPL_MARKETING_CONSENT_GRANTED] = 'Marketing consent granted';
NOTIFICATION_RULE_TEMPLATES[TPL_PRIVACY_POLICY_ACCEPTED] = 'Privacy policy accepted';
NOTIFICATION_RULE_TEMPLATES[TPL_HAS_SUBBOOKINGS] = 'Booking has subbookings';
NOTIFICATION_RULE_TEMPLATES[DATETIME_WITHIN_RANGE] = 'Datetime within range';
NOTIFICATION_RULE_TEMPLATES[DATE_WITHIN_RANGE] = 'Date within range';
NOTIFICATION_RULE_TEMPLATES[TIME_WITHIN_RANGE] = 'Time within range';
NOTIFICATION_RULE_TEMPLATES[HAS_REAL_GUEST_NAMES] = 'Booking has real guest names';

export const TOUR_PARTICIPANT_SOURCES: IntStringMap = {
    0: "Dashboard",
    1: "Self-registration",
    2: "Trip code",
    3: "XML",
    4: "Integration",
    5: "Other",
    6: "Tag",
    7: "Booking reference",
    9: "Catalog",
    10: "Parent booking",

}

export const TOUR_PARTICIPANT_SURVEY_STATES: IntStringMap = {
    0: "Not sent",
    1: "Sent",
    2: "Opened",
    3: "Submitted",
    4: "Not needed",
    5: "Emitted, but not sent yet",
}

export const EVENT_DELIVERY_STATES: IntStringMap = {};
export const EVENT_DELIVERY_EMITTED = 0;
export const EVENT_DELIVERY_NO_MATCH = 1;
export const EVENT_DELIVERY_RENDERING = 2;
export const EVENT_DELIVERY_SCHEDULED = 3;
export const EVENT_DELIVERY_DELIVERED = 4;
export const EVENT_DELIVERY_ERROR = 5;
export const EVENT_DELIVERY_PARTIALLY_DELIVERED = 6;
export const EVENT_DELIVERY_NOT_DELIVERED = 7;
export const EVENT_DELIVERY_DELIVERED_WITH_ERRORS = 8;
export const EVENT_DELIVERY_ORPHANED = 9;
// A sandbox tenant's outcomes (SBX D5; S4b): expected, never errors. See notifications/deliveryStatus.js.
export const EVENT_DELIVERY_SENT_ALLOWLISTED = 13;
export const EVENT_DELIVERY_PARTIALLY_SENT_ALLOWLISTED = 14;
export const EVENT_DELIVERY_CAPTURED = 15;
EVENT_DELIVERY_STATES[EVENT_DELIVERY_EMITTED] = 'Emitted';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_NO_MATCH] = 'No match';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_RENDERING] = 'Rendering';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_SCHEDULED] = 'Scheduled';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_DELIVERED] = 'Delivered';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_ERROR] = 'Error';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_PARTIALLY_DELIVERED] = 'Partially delivered';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_NOT_DELIVERED] = 'Not delivered';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_DELIVERED_WITH_ERRORS] = 'Delivered with errors';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_ORPHANED] = 'Orphaned';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_SENT_ALLOWLISTED] = 'Sent (allowlisted)';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_PARTIALLY_SENT_ALLOWLISTED] = 'Partially sent (allowlisted)';
EVENT_DELIVERY_STATES[EVENT_DELIVERY_CAPTURED] = 'Captured (sandbox)';

export const NOTIFICATION_STRING_TYPES: IntStringMap = {};
export const NOTIFICATION_STRING_TYPE_REMINDER = 0;
export const NOTIFICATION_STRING_TYPE_CALL_TO_ACTION = 1;
export const NOTIFICATION_STRING_TYPE_DEPARTURE_TIME_INFO = 2;
export const NOTIFICATION_STRING_TYPE_NOTE = 3;
NOTIFICATION_STRING_TYPES[NOTIFICATION_STRING_TYPE_REMINDER] = "Reminder";
NOTIFICATION_STRING_TYPES[NOTIFICATION_STRING_TYPE_CALL_TO_ACTION] = "Call to action";
NOTIFICATION_STRING_TYPES[NOTIFICATION_STRING_TYPE_DEPARTURE_TIME_INFO] = "Departure time info";
NOTIFICATION_STRING_TYPES[NOTIFICATION_STRING_TYPE_NOTE] = "Note";

export const TEMPLATE_LANGUAGE_JINJA2 = 'jinja2';
export const TEMPLATE_LANGUAGE_DJANGO = 'django';
export const TEMPLATE_LANGUAGES: StringStringMap = {};
TEMPLATE_LANGUAGES[TEMPLATE_LANGUAGE_JINJA2] = 'Jinja2';
TEMPLATE_LANGUAGES[TEMPLATE_LANGUAGE_DJANGO] = 'Django';

export const CHECKIN_SOURCES: IntStringMap = {};
export const CHECKIN_LOCAL = 0;
export const CHECKIN_RESTECH = 1;
export const CHECKIN_DASHBOARD = 2;
export const CHECKIN_TEST = 3;
CHECKIN_SOURCES[CHECKIN_LOCAL] = "App";
CHECKIN_SOURCES[CHECKIN_RESTECH] = "Booking system";
CHECKIN_SOURCES[CHECKIN_DASHBOARD] = "Dashboard";
CHECKIN_SOURCES[CHECKIN_TEST] = "Test";

export const checkinSourceOptions = genOptions(CHECKIN_SOURCES);
export const checkinSourceHtmlOptions = genHtmlOptions(CHECKIN_SOURCES);
export const checkinSourceMenuItems = genMenuItems(CHECKIN_SOURCES);

export const PRECHECKIN_STATUSES: IntStringMap = {};
export const PRECHECKIN_STATUS_NOT_COMPLETED = 0;
export const PRECHECKIN_STATUS_PARTIAL = 1;
export const PRECHECKIN_STATUS_COMPLETED = 2;
// Every guest saved details (or was skipped), but the final waivers/consent screen was not submitted.
export const PRECHECKIN_STATUS_DETAILS_COMPLETED = 3;
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_NOT_COMPLETED] = "Not completed";
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_PARTIAL] = "Partially completed";
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_DETAILS_COMPLETED] = "Details completed";
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_COMPLETED] = "Completed";

// Progress order, 0 → 1 → 3 → 2: listing by key would put "Details completed" after "Completed".
// Rule 60 stores the selection as these string codes, e.g. {"precheckin_statuses": ["1", "3"]}.
export const PRECHECKIN_STATUS_ORDER = [
    PRECHECKIN_STATUS_NOT_COMPLETED, PRECHECKIN_STATUS_PARTIAL, PRECHECKIN_STATUS_DETAILS_COMPLETED, PRECHECKIN_STATUS_COMPLETED,
].map(String);

export const precheckinStatusOptions = genOptions(PRECHECKIN_STATUSES, PRECHECKIN_STATUS_ORDER);
export const precheckinStatusHtmlOptions = genHtmlOptions(PRECHECKIN_STATUSES, {}, PRECHECKIN_STATUS_ORDER);
export const precheckinStatusMenuItems = genMenuItems(PRECHECKIN_STATUSES, PRECHECKIN_STATUS_ORDER);

// type of settlement method: 
// Direct - the full amount was paid to you, 
// Voucher - you need to settle the payment with a 3rd party, 
// Deposit - a deposit was paid in the course of the transaction, 
// Wholesale - the reseller paid you the wholesale price, 
// Deferred - there is a balance remaining on the order
export const SETTLEMENT_METHODS: StringStringMap = {};
export const SETTLEMENT_METHOD_DIRECT = "DIRECT";
export const SETTLEMENT_METHOD_VOUCHER = "VOUCHER";
export const SETTLEMENT_METHOD_DEPOSIT = "DEPOSIT";
export const SETTLEMENT_METHOD_WHOLESALE = "WHOLESALE";
export const SETTLEMENT_METHOD_DEFERRED = "DEFERRED";
SETTLEMENT_METHODS[SETTLEMENT_METHOD_DIRECT] = "Direct";
SETTLEMENT_METHODS[SETTLEMENT_METHOD_VOUCHER] = "Voucher";
SETTLEMENT_METHODS[SETTLEMENT_METHOD_DEPOSIT] = "Deposit";
SETTLEMENT_METHODS[SETTLEMENT_METHOD_WHOLESALE] = "Wholesale";
SETTLEMENT_METHODS[SETTLEMENT_METHOD_DEFERRED] = "DEFERRED";

export const settlementMethodOptions = genOptions(SETTLEMENT_METHODS);
export const settlementMethodHtmlOptions = genHtmlOptions(SETTLEMENT_METHODS);
export const settlementMethodMenuItems = genMenuItems(SETTLEMENT_METHODS);

export const ruleTemplatesOptions = Object.entries(NOTIFICATION_RULE_TEMPLATES).map(([value, label]) => ({
    value: parseInt(value),  
    label: label
}));
export const ruleTemplatesHtmlOptions = genHtmlOptions(NOTIFICATION_RULE_TEMPLATES);
export const ruleTemplatesMenuItems = genMenuItems(NOTIFICATION_RULE_TEMPLATES);

export const eventsOptions = genOptions(EVENTS);
export const eventsHtmlOptions = genHtmlOptions(EVENTS);
export const eventsMenuItems = genMenuItems(EVENTS);

export const deliveryMethodsOptions = genOptions(DELIVERY_METHODS);
export const deliveryMethodsHtmlOptions = genHtmlOptions(DELIVERY_METHODS);
export const deliveryMethodsMenuItems = genMenuItems(DELIVERY_METHODS);

export const opsOptions = genOptions(OPS);
export const opsHtmlOptions = genHtmlOptions(OPS);
export const opsMenuItems = genMenuItems(OPS);

export const deliveryOrderingOptions = genOptions(DELIVERY_ORDERING);
export const deliveryOrderingHtmlOptions = genHtmlOptions(DELIVERY_ORDERING);
export const deliveryOrderingMenuItems = genMenuItems(DELIVERY_ORDERING);

export const rulesMatchTypesOptions = genOptions(RULES_MATCH_TYPES);
export const rulesMatchTypesHtmlOptions = genHtmlOptions(RULES_MATCH_TYPES);
export const rulesMatchTypesMenuItems = genMenuItems(RULES_MATCH_TYPES);

export const emailDestinationOptions = genOptions(DELIVERY_METHOD_EMAIL_DESTINATION);
export const emailDestinationHtmlOptions = genHtmlOptions(DELIVERY_METHOD_EMAIL_DESTINATION);
export const emailDestinationMenuItems = genMenuItems(DELIVERY_METHOD_EMAIL_DESTINATION);

export const smsDestinationOptions = genOptions(DELIVERY_METHOD_SMS_DESTINATION);
export const smsDestinationHtmlOptions = genHtmlOptions(DELIVERY_METHOD_SMS_DESTINATION);
export const smsDestinationMenuItems = genMenuItems(DELIVERY_METHOD_SMS_DESTINATION);

export const whatsappDestinationOptions = genOptions(DELIVERY_METHOD_WHATSAPP_DESTINATION);
export const whatsappDestinationHtmlOptions = genHtmlOptions(DELIVERY_METHOD_WHATSAPP_DESTINATION);
export const whatsappDestinationMenuItems = genMenuItems(DELIVERY_METHOD_WHATSAPP_DESTINATION);

export const airbnbDestinationOptions = genOptions(DELIVERY_METHOD_AIRBNB_DESTINATION);
export const airbnbDestinationHtmlOptions = genHtmlOptions(DELIVERY_METHOD_AIRBNB_DESTINATION);
export const airbnbDestinationMenuItems = genMenuItems(DELIVERY_METHOD_AIRBNB_DESTINATION);

export const chatDestinationOptions = genOptions(DELIVERY_METHOD_CHAT_DESTINATION);
export const chatDestinationHtmlOptions = genHtmlOptions(DELIVERY_METHOD_CHAT_DESTINATION);
export const chatDestinationMenuItems = genMenuItems(DELIVERY_METHOD_CHAT_DESTINATION);

export const chatOriginOptions = genOptions(DELIVERY_METHOD_CHAT_ORIGIN);
export const chatOriginHtmlOptions = genHtmlOptions(DELIVERY_METHOD_CHAT_ORIGIN);
export const chatOriginMenuItems = genMenuItems(DELIVERY_METHOD_CHAT_ORIGIN);

export const notificationStringOptions = genOptions(NOTIFICATION_STRING_TYPES);
export const notificationStringHtmlOptions = genHtmlOptions(NOTIFICATION_STRING_TYPES);
export const notificationStringMenuItems = genMenuItems(NOTIFICATION_STRING_TYPES);

export const notificationReactionOptions = genHtmlOptions(NOTIFICATION_REACTIONS);

export const ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS: IntStringMap = {};
export const DELIVERY_METHOD_SUCCESSFUL = 0;
export const DELIVERY_METHOD_UNSUCCESSFUL = 1;
export const DELIVERY_METHOD_READ = 2;
export const DELIVERY_METHOD_UNREAD = 3;
ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS[DELIVERY_METHOD_SUCCESSFUL] = 'Successful';
ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS[DELIVERY_METHOD_UNSUCCESSFUL] = 'Unsuccessful';
ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS[DELIVERY_METHOD_READ] = 'Read';
ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS[DELIVERY_METHOD_UNREAD] = 'Unread';
export const advancedDeliveryConditionOptions = genOptions(ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS);
export const advancedDeliveryConditionHtmlOptions = genHtmlOptions(ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS);
export const advancedDeliveryConditionMenuItems = genMenuItems(ADVANCED_DELIVERY_METHOD_RULE_CONDITIONS);
export const CONDITION_ALL = 0;
export const CONDITION_ANY = 1;

export const LOCK_NONE = 0;
export const LOCK_USER = 1;

export const ConfirmationDialogText = {
    save_notification: { title: 'Save changes before leaving?', body: 'You have unsaved changes', okButtonText: 'Save', cancelButtonText: 'Cancel' },
    delete_notification: { title: 'INFO!', body: 'You are about to delete a notification - ', okButtonText: 'Delete notification', cancelButtonText: 'Cancel' },
    delete_notifications: { title: 'Please confirm', body: '', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    add_reaction_info: { title: 'INFO!', body: `Adding a reaction will send additional notification named "user missed notification" upon selected user behavior.`, okButtonText: 'OK', cancelButtonText: 'CLOSE' },
    duplicate_notification: { title: 'INFO!', body: `You are about to duplicate a notification - `, okButtonText: 'Create', cancelButtonText: 'Cancel' },
    duplicate_campaign: { title: 'INFO!', body: `You are about to duplicate a campaign - `, okButtonText: 'Create', cancelButtonText: 'Cancel' },
    delete_campaign: { title: 'INFO!', body: 'You are about to delete a campaign - ', okButtonText: 'Delete campaign', cancelButtonText: 'Cancel' },
    delete_delivery_method: { title: 'INFO!', body: `You are about to delete a delivery method`, okButtonText: 'Delete', cancelButtonText: 'Cancel' },
};

export const language_iso_codes = [
    {
        code: 'ab',
        id: 0,
        name: 'Abkhaz',
    },
    {
        code: 'aa',
        id: 1,
        name: 'Afar',
    },
    {
        code: 'af',
        id: 2,
        name: 'Afrikaans',
    },
    {
        code: 'ak',
        id: 3,
        name: 'Akan',
    },
    {
        code: 'sq',
        id: 4,
        name: 'Albanian',
    },
    {
        code: 'am',
        id: 5,
        name: 'Amharic',
    },
    {
        code: 'ar',
        id: 6,
        name: 'Arabic',
    },
    {
        code: 'an',
        id: 7,
        name: 'Aragonese',
    },
    {
        code: 'hy',
        id: 8,
        name: 'Armenian',
    },
    {
        code: 'as',
        id: 9,
        name: 'Assamese',
    },
    {
        code: 'av',
        id: 10,
        name: 'Avaric',
    },
    {
        code: 'ae',
        id: 11,
        name: 'Avestan',
    },
    {
        code: 'ay',
        id: 12,
        name: 'Aymara',
    },
    {
        code: 'az',
        id: 13,
        name: 'Azerbaijani',
    },
    {
        code: 'bm',
        id: 14,
        name: 'Bambara',
    },
    {
        code: 'ba',
        id: 15,
        name: 'Bashkir',
    },
    {
        code: 'eu',
        id: 16,
        name: 'Basque',
    },
    {
        code: 'be',
        id: 17,
        name: 'Belarusian',
    },
    {
        code: 'bn',
        id: 18,
        name: 'Bengali; Bangla',
    },
    {
        code: 'bh',
        id: 19,
        name: 'Bihari',
    },
    {
        code: 'bi',
        id: 20,
        name: 'Bislama',
    },
    {
        code: 'bs',
        id: 21,
        name: 'Bosnian',
    },
    {
        code: 'br',
        id: 22,
        name: 'Breton',
    },
    {
        code: 'bg',
        id: 23,
        name: 'Bulgarian',
    },
    {
        code: 'my',
        id: 24,
        name: 'Burmese',
    },
    {
        code: 'ca',
        id: 25,
        name: 'Catalan; Valencian',
    },
    {
        code: 'ch',
        id: 26,
        name: 'Chamorro',
    },
    {
        code: 'ce',
        id: 27,
        name: 'Chechen',
    },
    {
        code: 'ny',
        id: 28,
        name: 'Chichewa; Chewa; Nyanja',
    },
    {
        code: 'zh',
        id: 29,
        name: 'Chinese',
    },
    {
        code: 'cv',
        id: 30,
        name: 'Chuvash',
    },
    {
        code: 'kw',
        id: 31,
        name: 'Cornish',
    },
    {
        code: 'co',
        id: 32,
        name: 'Corsican',
    },
    {
        code: 'cr',
        id: 33,
        name: 'Cree',
    },
    {
        code: 'hr',
        id: 34,
        name: 'Croatian',
    },
    {
        code: 'cs',
        id: 35,
        name: 'Czech',
    },
    {
        code: 'da',
        id: 36,
        name: 'Danish',
    },
    {
        code: 'dv',
        id: 37,
        name: 'Divehi; Dhivehi; Maldivian;',
    },
    {
        code: 'nl',
        id: 38,
        name: 'Dutch',
    },
    {
        code: 'dz',
        id: 39,
        name: 'Dzongkha',
    },
    {
        code: 'en',
        id: 40,
        name: 'English',
    },
    {
        code: 'eo',
        id: 41,
        name: 'Esperanto',
    },
    {
        code: 'et',
        id: 42,
        name: 'Estonian',
    },
    {
        code: 'ee',
        id: 43,
        name: 'Ewe',
    },
    {
        code: 'fo',
        id: 44,
        name: 'Faroese',
    },
    {
        code: 'fj',
        id: 45,
        name: 'Fijian',
    },
    {
        code: 'fi',
        id: 46,
        name: 'Finnish',
    },
    {
        code: 'fr',
        id: 47,
        name: 'French',
    },
    {
        code: 'ff',
        id: 48,
        name: 'Fula; Fulah; Pulaar; Pular',
    },
    {
        code: 'gl',
        id: 49,
        name: 'Galician',
    },
    {
        code: 'ka',
        id: 50,
        name: 'Georgian',
    },
    {
        code: 'de',
        id: 51,
        name: 'German',
    },
    {
        code: 'el',
        id: 52,
        name: 'Greek, Modern',
    },
    {
        code: 'gn',
        id: 53,
        name: 'GuaranÃ­',
    },
    {
        code: 'gu',
        id: 54,
        name: 'Gujarati',
    },
    {
        code: 'ht',
        id: 55,
        name: 'Haitian; Haitian Creole',
    },
    {
        code: 'ha',
        id: 56,
        name: 'Hausa',
    },
    {
        code: 'he',
        id: 57,
        name: 'Hebrew (modern)',
    },
    {
        code: 'hz',
        id: 58,
        name: 'Herero',
    },
    {
        code: 'hi',
        id: 59,
        name: 'Hindi',
    },
    {
        code: 'ho',
        id: 60,
        name: 'Hiri Motu',
    },
    {
        code: 'hu',
        id: 61,
        name: 'Hungarian',
    },
    {
        code: 'ia',
        id: 62,
        name: 'Interlingua',
    },
    {
        code: 'id',
        id: 63,
        name: 'Indonesian',
    },
    {
        code: 'ie',
        id: 64,
        name: 'Interlingue',
    },
    {
        code: 'ga',
        id: 65,
        name: 'Irish',
    },
    {
        code: 'ig',
        id: 66,
        name: 'Igbo',
    },
    {
        code: 'ik',
        id: 67,
        name: 'Inupiaq',
    },
    {
        code: 'io',
        id: 68,
        name: 'Ido',
    },
    {
        code: 'is',
        id: 69,
        name: 'Icelandic',
    },
    {
        code: 'it',
        id: 70,
        name: 'Italian',
    },
    {
        code: 'iu',
        id: 71,
        name: 'Inuktitut',
    },
    {
        code: 'ja',
        id: 72,
        name: 'Japanese',
    },
    {
        code: 'jv',
        id: 73,
        name: 'Javanese',
    },
    {
        code: 'kl',
        id: 74,
        name: 'Kalaallisut, Greenlandic',
    },
    {
        code: 'kn',
        id: 75,
        name: 'Kannada',
    },
    {
        code: 'kr',
        id: 76,
        name: 'Kanuri',
    },
    {
        code: 'ks',
        id: 77,
        name: 'Kashmiri',
    },
    {
        code: 'kk',
        id: 78,
        name: 'Kazakh',
    },
    {
        code: 'km',
        id: 79,
        name: 'Khmer',
    },
    {
        code: 'ki',
        id: 80,
        name: 'Kikuyu, Gikuyu',
    },
    {
        code: 'rw',
        id: 81,
        name: 'Kinyarwanda',
    },
    {
        code: 'ky',
        id: 82,
        name: 'Kyrgyz',
    },
    {
        code: 'kv',
        id: 83,
        name: 'Komi',
    },
    {
        code: 'kg',
        id: 84,
        name: 'Kongo',
    },
    {
        code: 'ko',
        id: 85,
        name: 'Korean',
    },
    {
        code: 'ku',
        id: 86,
        name: 'Kurdish',
    },
    {
        code: 'kj',
        id: 87,
        name: 'Kwanyama, Kuanyama',
    },
    {
        code: 'la',
        id: 88,
        name: 'Latin',
    },
    {
        code: 'lb',
        id: 89,
        name: 'Luxembourgish, Letzeburgesch',
    },
    {
        code: 'lg',
        id: 90,
        name: 'Ganda',
    },
    {
        code: 'li',
        id: 91,
        name: 'Limburgish, Limburgan, Limburger',
    },
    {
        code: 'ln',
        id: 92,
        name: 'Lingala',
    },
    {
        code: 'lo',
        id: 93,
        name: 'Lao',
    },
    {
        code: 'lt',
        id: 94,
        name: 'Lithuanian',
    },
    {
        code: 'lu',
        id: 95,
        name: 'Luba-Katanga',
    },
    {
        code: 'lv',
        id: 96,
        name: 'Latvian',
    },
    {
        code: 'gv',
        id: 97,
        name: 'Manx',
    },
    {
        code: 'mk',
        id: 98,
        name: 'Macedonian',
    },
    {
        code: 'mg',
        id: 99,
        name: 'Malagasy',
    },
    {
        code: 'ms',
        id: 100,
        name: 'Malay',
    },
    {
        code: 'ml',
        id: 101,
        name: 'Malayalam',
    },
    {
        code: 'mt',
        id: 102,
        name: 'Maltese',
    },
    {
        code: 'mi',
        id: 103,
        name: 'MÄori',
    },
    {
        code: 'mr',
        id: 104,
        name: 'Marathi (MarÄá¹­hÄ«)',
    },
    {
        code: 'mh',
        id: 105,
        name: 'Marshallese',
    },
    {
        code: 'mn',
        id: 106,
        name: 'Mongolian',
    },
    {
        code: 'na',
        id: 107,
        name: 'Nauru',
    },
    {
        code: 'nv',
        id: 108,
        name: 'Navajo, Navaho',
    },
    {
        code: 'nb',
        id: 109,
        name: 'Norwegian BokmÃ¥l',
    },
    {
        code: 'nd',
        id: 110,
        name: 'North Ndebele',
    },
    {
        code: 'ne',
        id: 111,
        name: 'Nepali',
    },
    {
        code: 'ng',
        id: 112,
        name: 'Ndonga',
    },
    {
        code: 'nn',
        id: 113,
        name: 'Norwegian Nynorsk',
    },
    {
        code: 'no',
        id: 114,
        name: 'Norwegian',
    },
    {
        code: 'ii',
        id: 115,
        name: 'Nuosu',
    },
    {
        code: 'nr',
        id: 116,
        name: 'South Ndebele',
    },
    {
        code: 'oc',
        id: 117,
        name: 'Occitan',
    },
    {
        code: 'oj',
        id: 118,
        name: 'Ojibwe, Ojibwa',
    },
    {
        code: 'cu',
        id: 119,
        name: 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
    },
    {
        code: 'om',
        id: 120,
        name: 'Oromo',
    },
    {
        code: 'or',
        id: 121,
        name: 'Oriya',
    },
    {
        code: 'os',
        id: 122,
        name: 'Ossetian, Ossetic',
    },
    {
        code: 'pa',
        id: 123,
        name: 'Panjabi, Punjabi',
    },
    {
        code: 'pi',
        id: 124,
        name: 'PÄli',
    },
    {
        code: 'fa',
        id: 125,
        name: 'Persian (Farsi)',
    },
    {
        code: 'pl',
        id: 126,
        name: 'Polish',
    },
    {
        code: 'ps',
        id: 127,
        name: 'Pashto, Pushto',
    },
    {
        code: 'pt',
        id: 128,
        name: 'Portuguese',
    },
    {
        code: 'qu',
        id: 129,
        name: 'Quechua',
    },
    {
        code: 'rm',
        id: 130,
        name: 'Romansh',
    },
    {
        code: 'rn',
        id: 131,
        name: 'Kirundi',
    },
    {
        code: 'ro',
        id: 132,
        name: 'Romanian, [])',
    },
    {
        code: 'ru',
        id: 133,
        name: 'Russian',
    },
    {
        code: 'sa',
        id: 134,
        name: 'Sanskrit (Saá¹ská¹›ta)',
    },
    {
        code: 'sc',
        id: 135,
        name: 'Sardinian',
    },
    {
        code: 'sd',
        id: 136,
        name: 'Sindhi',
    },
    {
        code: 'se',
        id: 137,
        name: 'Northern Sami',
    },
    {
        code: 'sm',
        id: 138,
        name: 'Samoan',
    },
    {
        code: 'sg',
        id: 139,
        name: 'Sango',
    },
    {
        code: 'sr',
        id: 140,
        name: 'Serbian',
    },
    {
        code: 'gd',
        id: 141,
        name: 'Scottish Gaelic; Gaelic',
    },
    {
        code: 'sn',
        id: 142,
        name: 'Shona',
    },
    {
        code: 'si',
        id: 143,
        name: 'Sinhala, Sinhalese',
    },
    {
        code: 'sk',
        id: 144,
        name: 'Slovak',
    },
    {
        code: 'sl',
        id: 145,
        name: 'Slovene',
    },
    {
        code: 'so',
        id: 146,
        name: 'Somali',
    },
    {
        code: 'st',
        id: 147,
        name: 'Southern Sotho',
    },
    {
        code: 'es',
        id: 148,
        name: 'Spanish; Castilian',
    },
    {
        code: 'su',
        id: 149,
        name: 'Sundanese',
    },
    {
        code: 'sw',
        id: 150,
        name: 'Swahili',
    },
    {
        code: 'ss',
        id: 151,
        name: 'Swati',
    },
    {
        code: 'sv',
        id: 152,
        name: 'Swedish',
    },
    {
        code: 'ta',
        id: 153,
        name: 'Tamil',
    },
    {
        code: 'te',
        id: 154,
        name: 'Telugu',
    },
    {
        code: 'tg',
        id: 155,
        name: 'Tajik',
    },
    {
        code: 'th',
        id: 156,
        name: 'Thai',
    },
    {
        code: 'ti',
        id: 157,
        name: 'Tigrinya',
    },
    {
        code: 'bo',
        id: 158,
        name: 'Tibetan Standard, Tibetan, Central',
    },
    {
        code: 'tk',
        id: 159,
        name: 'Turkmen',
    },
    {
        code: 'tl',
        id: 160,
        name: 'Tagalog',
    },
    {
        code: 'tn',
        id: 161,
        name: 'Tswana',
    },
    {
        code: 'to',
        id: 162,
        name: 'Tonga (Tonga Islands)',
    },
    {
        code: 'tr',
        id: 163,
        name: 'Turkish',
    },
    {
        code: 'ts',
        id: 164,
        name: 'Tsonga',
    },
    {
        code: 'tt',
        id: 165,
        name: 'Tatar',
    },
    {
        code: 'tw',
        id: 166,
        name: 'Twi',
    },
    {
        code: 'ty',
        id: 167,
        name: 'Tahitian',
    },
    {
        code: 'ug',
        id: 168,
        name: 'Uyghur, Uighur',
    },
    {
        code: 'uk',
        id: 169,
        name: 'Ukrainian',
    },
    {
        code: 'ur',
        id: 170,
        name: 'Urdu',
    },
    {
        code: 'uz',
        id: 171,
        name: 'Uzbek',
    },
    {
        code: 've',
        id: 172,
        name: 'Venda',
    },
    {
        code: 'vi',
        id: 173,
        name: 'Vietnamese',
    },
    {
        code: 'vo',
        id: 174,
        name: 'VolapÃ¼k',
    },
    {
        code: 'wa',
        id: 175,
        name: 'Walloon',
    },
    {
        code: 'cy',
        id: 176,
        name: 'Welsh',
    },
    {
        code: 'wo',
        id: 177,
        name: 'Wolof',
    },
    {
        code: 'fy',
        id: 178,
        name: 'Western Frisian',
    },
    {
        code: 'xh',
        id: 179,
        name: 'Xhosa',
    },
    {
        code: 'yi',
        id: 180,
        name: 'Yiddish',
    },
    {
        code: 'yo',
        id: 181,
        name: 'Yoruba',
    },
    {
        code: 'za',
        id: 182,
        name: 'Zhuang, Chuang',
    },
    {
        code: 'zu',
        id: 183,
        name: 'Zulu',
    },
];
